import type * as Api from 'Api'

export const captchaErrorHandbook: Api.ErrorsHandbook<'default'> = {
  default: [],
}
